(ns practitest.frontend.components.overflow
  (:require [practitest.frontend.common.dom :as dom]
            [reagent.core :as reagent]
            [reagent.dom]
            [practitest.frontend.components.tooltip :as tooltip]
            [practitest.frontend.common.format-utils :as fu]
            [practitest.frontend.common.utils :refer [register-components!]]))

(defn- get-ref-value [this ref]
  (cond
    (satisfies? IDeref ref)
    (deref ref)

    (fn? ref)
    (ref this)

    :else
    (js/console.warn "invalid value passed in get-ref-value" ref)))

(def ^:private emulate-no-resize-observer false)

(defn resize-callback-lifecycle
  [node-ref on-resize on-fallback reagent-render]
  (let [observer-ref (atom nil)]
    (reagent/create-class
      {:component-did-mount (fn [this]
                              (when-let [node (get-ref-value this node-ref)]
                                (if (and (not emulate-no-resize-observer)
                                         (exists? js/ResizeObserver))
                                  (let [observer (js/ResizeObserver. (fn [entries observer]
                                                                       (let [node (.-target (first entries))]
                                                                         (on-resize node))))]
                                    (reset! observer-ref observer)
                                    (.observe observer node))
                                  ;; Fallback mode
                                  (on-fallback))))
       ;; ResizeObserver only fires when the node's size changes. When the same
       ;; component is reused for different content (e.g. grid rows keyed by index
       ;; after filtering), the size stays the same, so re-measure on every update.
       :component-did-update (fn [this]
                               (when @observer-ref
                                 (when-let [node (get-ref-value this node-ref)]
                                   (on-resize node))))
       :component-will-unmount (fn []
                                 (when-let [observer @observer-ref]
                                   (.disconnect observer)))

       :reagent-render reagent-render})))

(defn- overflow-with-tooltip2
  [body-fn]
  (let [state (reagent/atom {:overflow? false
                             :observer? true})
        observer-ref (atom nil)]
    (resize-callback-lifecycle
      ;; TODO: replace with ref for React 19 compatibility ?
      (fn [this]
        ;; Use whatever root node is wrapped in this component
        (reagent.dom/dom-node this))
      (fn [node]
        (let [overflow? (dom/width-overflow? node)]
          (when-not (= overflow? (:overflow? @state))
            (swap! state assoc :overflow? overflow?))))
      (fn []
        (swap! state assoc :observer? false :overflow? true))
      (fn [body-fn]
        (body-fn @state)))))

(defn overflow-with-tooltip
  [element-fn text-or-fn]
  [overflow-with-tooltip2
   (fn [{:keys [overflow? observer?]}]
     (let [text (if (fn? text-or-fn)
                  (text-or-fn)
                  text-or-fn)]

       [tooltip/hover-tooltip
        ;; Tooltip body
        text
        ;; Wrapped element
        (fn [props]
          (element-fn
            (if observer?
              ;; Do not pass event handlers to span - will not trigger tooltip
              (when overflow?
                props)

              ;; fallback
              {:title text})))]))])

(defn ^{:component? true}
  overflow-with-mux-tooltip
  "Special component to show mouseUX styled tooltip when it's element is overflown.
   Need to be combined with CSS styling to trigger overflow.

   Uses ResizeObserver internally if available, fallbacks to browser-default `title` attribute

   * `element-fn` - `(fn [props])` - function will be triggered to render element, passed props should be attached to node that requires tooltip display
   * `text-or-fn` - `(fn [])` - static text to show in the tooltip, or callback function that will return text to render

   Available options:

   * See `mux-tooltip` for available tooltip options (will be passed on to that component)
   * `field_type` - if it's `:date-time` will render passed text as datetime object with default formatter
   "
  [options element-fn text-or-fn]
  [overflow-with-tooltip2
   (fn [{:keys [overflow? observer?]}]
     (let [text (if (fn? text-or-fn)
                  (text-or-fn)
                  text-or-fn)
           field-type (:field_type options)
           text (if (= field-type :date-time)
                  (fu/formatted-date-time text)
                  text)]
       [tooltip/mux-tooltip
        options
        text
        (fn [props]
          (element-fn
            (if observer?
              ;; Do not pass event handlers to span - will not trigger tooltip
              (when overflow?
                props)

              ;; fallback
              {:title text})))]))])

(register-components!)
